import { Modifier, State } from "@popperjs/core"
import { SxProps } from "@tm/components"
import { useLayoutEffect, useRef, useState } from "react"

/**
 * used to get the searchfield width and use the correct offset for the popper
 */
export function usePopperOptions() {
    const searchGroupRef = useRef<HTMLDivElement | null>(null)
    const [popperSx, setPopperSx] = useState<SxProps>()
    const [popperOffset, setPopperOffset] = useState<SxProps>()

    useLayoutEffect(() => {
        const node = searchGroupRef.current

        if (!node) {
            return
        }

        const updateAutoCompleteStyles = () => {
            const { width } = node.getBoundingClientRect()
            const left = node.offsetLeft

            setPopperSx({
                minWidth: `${width}px !important`,
                top: "-1px",
            })

            setPopperOffset({
                minWidth: `${width}px !important`,
                top: "-1px",
                left: `${left}px !important`,
            })
        }

        updateAutoCompleteStyles()

        const observer = new ResizeObserver(() => {
            updateAutoCompleteStyles()
        })
        observer.observe(node)

        return () => {
            observer.disconnect()
        }
    }, [searchGroupRef.current?.scrollWidth])

    const popperModifiers: Partial<Modifier<unknown, object>>[] = [
        // {
        //     name: "offset",
        //     options: {
        //         offset: [0, -1],
        //     },
        // },
        {
            name: "resetTranslateX",
            enabled: true,
            phase: "beforeWrite",
            fn: ({ state }: { state: State }) => {
                // Set transform translate x value to 0 to center the suggestions shown in the popper component
                const { transform } = state.styles.popper
                const CSSMatrix = window.DOMMatrix || window.WebKitCSSMatrix
                const transformMatrix = new CSSMatrix(transform === "none" ? undefined : transform)
                transformMatrix.m41 = 0
                // eslint-disable-next-line no-param-reassign
                state.styles.popper.transform = transformMatrix.toString()
            },
        },
    ]

    return { searchGroupRef, popperSx, popperModifiers, popperOffset }
}
